import { css } from '@emotion/css'

import { spacing, breakpoint, fontSize, borderRadius, mediaQueryHelper, shorthandHelper, hexToRgba, colors } from '@offerzen/pinata-shame'

const styles = {
  nameField: css({
    width: '100%',
    marginBottom: 0,
  }),

  firstNameField: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      paddingRight: spacing.small,
    },
  }),

  lastNameField: css({
    [mediaQueryHelper(breakpoint.phone)]: {
      paddingLeft: spacing.small,
    },
  }),

  nameFieldsContainer: css({
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  nameFieldInput: css({
    width: '100%',
    marginBottom: spacing.medium,
  }),

  login: css({
    marginTop: spacing.small,
    marginBottom: spacing.large,
    textAlign: 'left',
    fontSize: fontSize.default,

    a: {
      color: colors.cornflowerBlue,
    },
  }),

  button: css({
    width: '100%',
  }),

  inputReset: css({
    marginBottom: spacing.medium,
    width: '100%',
  }),

  // These styles are to override the ones inherited by rails

  textInput: css({
    '& input': {
      border: 'none !important',
      height: '100% !important',
    },
  }),

  searchInput: css({
    width: '100%',
    marginBottom: spacing.medium,
  }),

  searchError: css({
    '& div': {
      borderColor: colors.mandy,
    },

    '& input': {
      '&:focus': {
        border: 'transparent !important',
        borderColor: `${colors.mandy} !important`,
        boxShadow: `0 0 0 3px ${hexToRgba(colors.mandy, 0.25)}`,
        borderRadius: borderRadius.medium,
      },

      '&:focus-within': {
        border: 'transparent !important',
        borderColor: `${colors.mandy} !important`,
        boxShadow: `0 0 0 3px ${hexToRgba(colors.mandy, 0.25)}`,
        borderRadius: borderRadius.medium,
      },
    },
  }),

  checkbox: css({
    alignItems: 'flex-start',
    marginBottom: spacing.medium,
    '&:last-of-type': {
      marginBottom: spacing.large,
    },
    '& label': {
      marginBottom: 0, // override rails styles
    },
    a: {
      color: colors.cornflowerBlue,
    },
  }),

  notification: css({
    margin: shorthandHelper([spacing.default, 0, spacing.large, 0]),
  }),

  recaptchaNotice: css({
    padding: shorthandHelper([0, spacing.large]),
    width: '100%',
    marginTop: spacing.extraLarge,
    color: colors.geyser,
    textAlign: 'center',
    fontSize: fontSize.default,
    [mediaQueryHelper(breakpoint.phone)]: {
      paddingTop: 0,
      paddingBottom: spacing.extraLarge,
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    [mediaQueryHelper(breakpoint.desktop)]: {
      paddingBottom: spacing.extraLarge,
    },
    '& a': {
      color: colors.geyser,
      textDecoration: 'underline',
    },
  }),

  disclaimer: css({
    marginTop: spacing.medium,
    fontSize: fontSize.default,
    marginBottom: 0,
    '& a': {
      color: colors.cornflowerBlue,
    },
  }),

  errorNotification: css({
    marginBottom: spacing.medium,
  }),
}

export default styles
